var _ellipse, _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnstakeSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 150,
    viewBox: "0 0 280 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.5,
    cy: 137,
    rx: 102.5,
    ry: 13,
    fill: "url(#paint0_linear_4886_46773)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.014,
    y: 42.252,
    width: 102.986,
    height: 102.986,
    rx: 6,
    fill: "#2726BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.5154,
    height: 102.708,
    rx: 6,
    transform: "matrix(-1 0 0 1 105.516 42.2529)",
    fill: "url(#paint1_linear_4886_46773)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32.6797,
    height: 102.708,
    rx: 6,
    transform: "matrix(-1 0 0 1 105.516 42.2529)",
    fill: "#2F5CFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4886_46773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 46,
    width: 92,
    height: 94
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.385,
    y: 46.499,
    width: 91.3072,
    height: 93.4306,
    rx: 6,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4886_46773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.385,
    y: 46.499,
    width: 91.3072,
    height: 93.4306,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.919 130.954H176.48L200.053 140.291H104.348L127.919 130.954Z",
    fill: "#ECEBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.501 132.704V29.9971L95.0098 51.5879L104.93 142.041L128.501 132.704Z",
    fill: "#ECEBE7",
    fillOpacity: 0.36
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5014,
    height: 22.1755,
    rx: 1.7507,
    transform: "matrix(-1 0 0 1 107.85 51.5898)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5014,
    height: 22.1755,
    rx: 1.7507,
    transform: "matrix(-1 0 0 1 107.85 114.615)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.909 78.4336H124.127V85.9717H167.909V78.4336Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.908 78.4336H131.518V85.9717H138.908V78.4336Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.916 78.4336H149.754V85.9717H167.916V78.4336Z",
    fill: "#2B303B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.946 85.9727H119.02V93.5107H163.946V85.9727Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.186 85.9727H126.602V93.5107H134.186V85.9727Z",
    fill: "#BBBBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.937 85.9727H145.307V93.5107H163.937V85.9727Z",
    fill: "#2B303B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.327 93.5088H124.4V101.047H169.327V93.5088Z",
    fill: "#808080"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.569 93.5088H131.984V101.047H139.569V93.5088Z",
    fill: "#BBBBBB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.318 93.5088H150.688V101.047H169.318V93.5088Z",
    fill: "#2B303B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159.78 101.049H114.854V108.587H159.78V101.049Z",
    fill: "#808080"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.026 101.049H122.441V108.587H130.026V101.049Z",
    fill: "#BBBBBB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.783 101.049H141.152V108.587H159.783V101.049Z",
    fill: "#2B303B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.196 108.634H120.27V116.172H165.196V108.634Z",
    fill: "#808080"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.436 108.634H127.852V116.172H135.436V108.634Z",
    fill: "#BBBBBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.191 108.634H146.561V116.172H165.191V108.634Z",
    fill: "#2B303B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.141 116.17H124.215V123.708H169.141V116.17Z",
    fill: "#808080"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.382 116.17H131.797V123.708H139.382V116.17Z",
    fill: "#BBBBBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.137 116.17H150.506V123.708H169.137V116.17Z",
    fill: "#2B303B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.196 123.71H120.27V131.248H165.196V123.71Z",
    fill: "#808080"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M135.436 123.71H127.852V131.248H135.436V123.71Z",
    fill: "#BBBBBB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.191 123.71H146.561V131.248H165.191V123.71Z",
    fill: "#2B303B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.333 136.772C193.132 133.285 199.09 121.619 195.597 110.8C192.104 99.9817 180.448 94.0022 169.649 97.489C158.85 100.976 152.892 112.642 156.385 123.461C159.878 134.279 171.534 140.259 182.333 136.772Z",
    fill: "#2B303B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.276 133.499C190.278 130.593 195.246 120.864 192.335 111.846C189.423 102.828 179.703 97.8422 170.701 100.749C161.699 103.655 156.731 113.384 159.643 122.402C162.554 131.42 172.274 136.406 181.276 133.499Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.721 107.658C169.784 108.606 167.586 110.781 166.501 113.433L167.712 113.928L169.184 114.53C169.955 112.638 171.52 111.092 173.612 110.417C176.895 109.357 180.39 110.801 182.036 113.692C182.276 114.113 182.477 114.565 182.632 115.044C183.096 116.482 183.081 117.958 182.679 119.3C182.027 121.486 180.347 123.321 178.021 124.072C177.71 124.173 177.396 124.249 177.078 124.309C173.918 124.874 170.745 123.246 169.359 120.345L167.928 121.029C169.619 124.576 173.5 126.566 177.362 125.873L177.594 127.164C178.035 127.084 178.48 126.977 178.919 126.835C182.191 125.779 184.553 123.2 185.466 120.13L184.208 119.754C184.698 118.113 184.712 116.311 184.146 114.555C183.957 113.97 183.71 113.416 183.421 112.9L184.562 112.248C182.249 108.188 177.343 106.16 172.725 107.651L172.721 107.658Z",
    fill: "#2B303B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.098 109.037L185.458 110.847C186.031 111.708 186.492 112.661 186.825 113.692C188.791 119.779 185.459 126.301 179.384 128.263C173.308 130.224 166.792 126.881 164.827 120.795C164.488 119.747 164.305 118.686 164.269 117.639L161.88 117.13C161.871 118.586 162.085 120.068 162.557 121.528C164.927 128.868 172.791 132.903 180.118 130.537C187.445 128.171 191.465 120.3 189.095 112.959C188.629 111.516 187.951 110.196 187.104 109.036L187.098 109.037Z",
    fill: "#2B303B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.26 106.226C177.106 104.662 182.237 106.47 185.109 110.362L186.736 108.569C183.223 104.14 177.214 102.122 171.528 103.958C165.842 105.794 162.168 110.913 161.891 116.542L164.259 117.045C164.339 112.231 167.431 107.786 172.26 106.226Z",
    fill: "#2B303B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.643 115.062C179.789 115.323 179.914 115.596 180.009 115.892C180.294 116.772 180.286 117.68 180.042 118.503C179.64 119.845 178.609 120.972 177.179 121.434C176.984 121.497 176.791 121.547 176.599 121.578C174.66 121.927 172.708 120.926 171.855 119.14C171.768 118.965 171.696 118.779 171.634 118.59C171.301 117.558 171.37 116.496 171.746 115.568C172.219 114.406 173.184 113.455 174.469 113.04C176.488 112.388 178.637 113.276 179.645 115.049L179.643 115.062Z",
    fill: "#2B303B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4886_46773",
    x1: 140.5,
    y1: 124,
    x2: 140.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4886_46773",
    x1: 19.2577,
    y1: 102.708,
    x2: 19.2577,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.346349,
    stopColor: "#3736DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstakeSuccess);
export default __webpack_public_path__ + "static/media/unstakeSuccess.5fcab220ffe5e156907f6f58d50eb28c.svg";
export { ForwardRef as ReactComponent };